import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import def from '../pic/default_pfp.png';
import Header from './Header';
import './Friend.css';

const Friend = () => {
  const [users, setUsers] = useState([]);
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserData();
    fetchFriendList();
  }, []);

  const fetchUserData = async () => {
    try {
      const userId = Cookies.get('userid');
      const token = Cookies.get('token');
      const response = await axios.get(`http://localhost:8080/api/users`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });
      console.log(response)
      const filteredUsers = response.data.filter(user => user.id !== parseInt(userId));
      setUsers(filteredUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
      setError('Failed to load users.');
    }
    setLoading(false);
  };

  const fetchFriendList = async () => {
    try {
      const userId = Cookies.get('userid');
      const token = Cookies.get('token');
      const response = await axios.get(`http://localhost:8080/friend/${userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });
      setFriends(response.data);
    } catch (error) {
      console.error('Error fetching friend list:', error);
      setError('Failed to load friend list.');
    }
    setLoading(false);
  };

  const handleAddFriend = async (friendId) => {
    try {
      const userId = Cookies.get('userid');
      const token = Cookies.get('token');

      const friendsList = [
        { userId: parseInt(userId), friendId: friendId, relation: "Reqee" },
        { userId: friendId, friendId: parseInt(userId), relation: "Reqed" },
      ];

      await axios.post(
        'http://localhost:8080/friend/add',
        friendsList,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      alert('Friend added successfully');
      fetchFriendList();
    } catch (error) {
      console.error('Error adding friend:', error);
      alert('Failed to add friend');
    }
  };

  const handleDeleteFriend = async (friendId) => {
    try {
      const userId = Cookies.get('userid');
      const token = Cookies.get('token');
  
      await axios.delete(`http://localhost:8080/friend/${userId}/${friendId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });
  
      alert('Friend deleted successfully');
      fetchFriendList(); // Refresh the list
    } catch (error) {
      console.error('Error deleting friend:', error);
      alert('Failed to delete friend');
    }
  };
  

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  const userId = parseInt(Cookies.get('userid'));

  const filteredUsers = users.filter(user => {
    const isAlreadyFriend = friends.some(friend =>
      (friend.userId === user.id && friend.friendId === userId) ||
      (friend.friendId === user.id && friend.userId === userId)
    );
    return !isAlreadyFriend;
  });

  const currentFriends = users.filter(user => {
    return friends.some(friend =>
      (friend.userId === user.id && friend.friendId === userId && friend.relation === 'Reqee') ||
      (friend.friendId === user.id && friend.userId === userId && friend.relation === 'Reqee')
    );
  });

  return (
    <>
      <Header />
      <div className="friend-list">
      <div className="friend-sections">
        <div className="section">
          <h1>Your Friends</h1>
          <div className="user-container">
            {currentFriends.length === 0 ? (
              <p>You have no friends yet.</p>
            ) : (
              currentFriends.map((friend) => (
                <div key={friend.id} className="user-box">
                  <img
                    src={friend.profile_pic ? `http://localhost:8080${friend.profile_pic}` : def}
                    alt={friend.username}
                    className="user-img"
                  />
                  <div className="username">{friend.username}</div>
                  <button
                    className="delete-friend-btn"
                    onClick={() => handleDeleteFriend(friend.id)}
                  >
                    Delete Friend
                  </button>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="section">
          <h1>All Users</h1>
          <div className="user-container">
            {filteredUsers.length === 0 ? (
              <p>No users available to add as friends</p>
            ) : (
              filteredUsers.map((user) => (
                <div key={user.id} className="user-box">
                  <img
                    src={user.profile_pic ? `http://localhost:8080${user.profile_pic}` : def}
                    alt={user.username}
                    className="user-img"
                  />
                  <div className="username">{user.username}</div>
                  <button
                    className="add-friend-btn"
                    onClick={() => handleAddFriend(user.id)}
                  >
                    Add Friend
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>

    </>
  );
};

export default Friend;
